import { createContext, useContext } from 'react'

export interface GrowerProgramsState {
  programsQuery: any
  addFields: boolean
  setAddFields: (status: boolean) => void
  onUnenroll(fieldId: string): void
}

const DEFAULT_VALUES: GrowerProgramsState = {
  programsQuery: undefined,
  addFields: false,
  setAddFields: () => null,
  onUnenroll: console.log,
}

export const GrowerProgramsContext = createContext<GrowerProgramsState>(DEFAULT_VALUES)
GrowerProgramsContext.displayName = 'GrowerProgramsContext'

export const useGrowerPrograms = () => useContext(GrowerProgramsContext)
